import api from "@helpers/api";
import { PackageCreateType } from "@type/procurements/package";

const apiEndPointForList = `${process.env.REACT_APP_EMPLOYEE_PROCUREMENT_SERVICE_BASE_URL}${process.env.REACT_APP_EMPLOYEE_PROCUREMENT_SERVICE_PORT}/${process.env.REACT_APP_EMPLOYEE_PROCUREMENT_SERVICE}/api/${process.env.REACT_APP_EMPLOYEE_PROCUREMENT_SERVICE_VERSION}/${process.env.REACT_APP_EMPLOYEE_PROCUREMENT_SERVICE_TYPE}/apps`;

const apiEndPoint = `${process.env.REACT_APP_EMPLOYEE_PROCUREMENT_SERVICE_BASE_URL}${process.env.REACT_APP_EMPLOYEE_PROCUREMENT_SERVICE_PORT}/${process.env.REACT_APP_EMPLOYEE_PROCUREMENT_SERVICE}/api/${process.env.REACT_APP_EMPLOYEE_PROCUREMENT_SERVICE_VERSION}/${process.env.REACT_APP_EMPLOYEE_PROCUREMENT_SERVICE_TYPE}/packages`;

export const fetchPackages = async (query: any) => {
  const res = await api.get(`${apiEndPointForList}/${query?.id}/packages`, {
    params: {
      page: query?.page,
      size: query?.size,
    },
  });

  return res;
};

export const fetchPackageById = async (id: number | string) => {
  const res = await api.get(`${apiEndPoint}/${id}`);

  return res;
};

export const createPackage = async (data: PackageCreateType) => {
  const res = await api.post(`${apiEndPointForList}/${data.appId}/packages`, {
    ...data,
  });

  return res;
};

export const updatePackage = async (id: string | number, data: any) => {
  const res = await api.put(`${apiEndPoint}/${id}`, {
    ...data,
  });

  return res;
};

export const deletePackage = async (id: string | number) => {
  const res = await api.delete(`${apiEndPoint}/${id}`);

  return res;
};
